import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { APIURL } from '../../config/config';
import axios from 'axios';
import moment from 'moment';
import { format } from 'date-fns';
import { AlertSuccess, AlertWarning } from '../Alert/Alert';

// is_after_sell ===  0 = ก่อนขาย // 1  หลังขาย
class SparePartStockOut extends Component {

  constructor (props){
    super(props);
    this.state = {
      actionType: 'บันทึก',
      out_date: new Date(),
      requestor: '',
      use_for: 'ใช้กับรถยนต์',
      sparePartSearchResult: [],
      isDeleteKey: false,
      stockOutItem: [],
      carUseIn: {
        car_id: '',
        car_name: '',
        car_license_plate_new: ''
      },
      carSearchResult: [],
      company_setting: {},
      center: {},
      sparePartSearchBarCodeResult: [],
      spare_part_barcode: '',
      out_note: '',
      car_license: '',
      is_after_sell: 0,
    }

    this.handleOutDate = this.handleOutDate.bind(this);
    this.onChangeUseFor = this.onChangeUseFor.bind(this);
    this.onChangeSearchCar = this.onChangeSearchCar.bind(this);
    this.addStockOutItem = this.addStockOutItem.bind(this);
    this.onChangeSearchSparePart = this.onChangeSearchSparePart.bind(this);
    this.onKeyDownSearchSparePart = this.onKeyDownSearchSparePart.bind(this);
    this.updateStockItem = this.updateStockItem.bind(this);
    this.selectCarUseIn = this.selectCarUseIn.bind(this);
    this.removeStockItem = this.removeStockItem.bind(this);
    this.onSubmitStockOut = this.onSubmitStockOut.bind(this);
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCenter = this.loadCenter.bind(this);

    this.onChangeSearchBarCodeSparePart = this.onChangeSearchBarCodeSparePart.bind(this);
    this.onKeyUpSearchBarCodeSparePart = this.onKeyUpSearchBarCodeSparePart.bind(this);
    this.getItemByBarcode = this.getItemByBarcode.bind(this);
  }

  componentDidMount () {
    this.loadCompanySetting();
    this.loadCenter();
  }

  handleOutDate(date) {
    this.setState({
      out_date: date,
    })
  }

  onChangeUseFor(e) {
    this.setState({
      use_for: e.currentTarget.value,
    })
  }

  onChangeSearchCar(e){
    let search = e.currentTarget.value

    if(search==='' || search.length <2) {
      if (search === '') {
        this.setState({
          carSearchResult: []
        });
      }
      return
    }

    axios.get(APIURL+'/stock_out/search/car/'+search)
      .then(res => {
        if(res.status===200){
          this.setState({
            carSearchResult: res.data
          });
        }
      })
  }

  onChangeSearchSparePart(e) {
    let search_text = e.currentTarget.value

    if (this.state.isDeleteKey) {
      return;
    }

    if(this.state.sparePartSearchResult.length === 1){
      return;
    }

    axios.get(APIURL+'/spare_part/search/'+search_text).then(res => {
      if(res.status === 200) {
        this.setState({
          sparePartSearchResult: res.data
        });
      }
    })
  }

  onKeyDownSearchSparePart(e) {
    if (e.keyCode === 8) {
      if(e.currentTarget.value.length <=3){
        this.setState({
          isDeleteKey: true,
          sparePartSearchResult: []
        });
      }else {
        this.setState({
          isDeleteKey: true
        });
      }
    }else{
      this.setState({
        isDeleteKey: false
      });
    }
  }

  onChangeSearchBarCodeSparePart(e) {
    let barcode = e.currentTarget.value

    this.setState({
      spare_part_barcode: barcode
    })

  }

  // onKeyDown={this.onKeyUpSearchBarCodeSparePart}
  // onKeyUp={this.onKeyUpSearchBarCodeSparePart}
  onKeyUpSearchBarCodeSparePart(e) {
    if (e.keyCode === 13) {
      e.preventDefault()
      this.getItemByBarcode()
      return
    }
  }

  getItemByBarcode() {
    let barcode = this.state.spare_part_barcode

    axios.get(APIURL+'/spare_part/barcode/'+barcode).then(res => {
      if(res.status === 200) {
        // this.setState({
        //   sparePartSearchBarCodeResult: res.data
        // });
        let data = res.data;
        if (data.length > 1) {
          AlertWarning('พบสินค้าตามบาร์โค้ด '+barcode+ ' มากกว่า 1 รายการ');
        } else if (data.length === 1) {
          // action
          let sparePart = data[0];
          if(sparePart.quantity_in===0){
            AlertWarning('จำนวนสินค้าไม่เพียงพอไม่สามารถเพิ่มรายการเบิกได้');
            this.setState({
              spare_part_barcode: ''
            });
            return;
          }

          // check สินค้าในตระกร้า กับใน stock
          let quantity_in = sparePart.quantity_in
          const existItemArr = this.state.stockOutItem.filter(item => item.id === sparePart.id)

          if (existItemArr.length!==0) {
            let existItem = existItemArr[0]
            if (existItem.quantity === quantity_in) {
              AlertWarning('จำนวนสินค้าไม่เพียงพอ');
              this.setState({
                spare_part_barcode: ''
              });
              return;
            }
          }

          this.setState({
            spare_part_barcode: ''
          }, this.addStockOutItem(sparePart))

        } else {
          AlertWarning('ไม่พบสินค้าตามบาร์โค้ด '+barcode+ ' กรุณาตรวจสอบ');
        }

      }
    })

  }

  addStockOutItem(sparePartItem) {
    let stockInItem = this.state.stockOutItem;

    // price , total
    let quantity = 1;
    let newItem = {
      id: sparePartItem.id,
      name: sparePartItem.name,
      price: sparePartItem.price,
      quantity: quantity,
      unit: sparePartItem.unit,
      stock_in: sparePartItem.quantity_in,
      total: quantity * parseFloat(sparePartItem.price),
      //barcode: sparePartItem.barcode
    }

    const existItem = this.state.stockOutItem.filter(item => item.id === sparePartItem.id)

    if (existItem.length===0) {
      stockInItem.push(newItem)
      this.setState({
        stockOutItem: stockInItem,
        sparePartSearchResult: [],
        //sparePartSearchBarCodeResult: [],
      },() => {
        this.refs.search_spare_part_out.value=''
      });
    } else{
      let stockInItem = this.state.stockOutItem.map(item => item.id === sparePartItem.id ? {...item, quantity: item.quantity + 1} : item)
      this.setState({
        stockOutItem: stockInItem,
        sparePartSearchResult: [],
        // sparePartSearchBarCodeResult: [],
      },() => {
        this.refs.search_spare_part_out.value=''
      });
    }
  }

  updateStockItem(event,itemStock){
    let quantity = isNaN(parseInt(event.currentTarget.value, 10)) ? '' : parseInt(event.currentTarget.value, 10)

    let stockOutItem = this.state.stockOutItem.map(item => {
      // item.id === itemStock.id ? {...item, quantity: quantity} : item
      if(item.id === itemStock.id) {
         if(quantity > itemStock.stock_in){
           alert('สต็อกไม่เพียงพอ กรุณาตรวจสอบ');
           return item;
         }else{
           let quantityTemp = quantity === '' ? 0 : quantity
           let total = quantityTemp * parseFloat(itemStock.price)
           return {...item, quantity: quantity, total: total}
         }
      }else{
        return item;
      }
    })

    this.setState({
      stockOutItem: stockOutItem,
    });
  }

  onSubmitStockOut(e) {
    e.preventDefault();



    if(this.state.requestor === ''){
      AlertWarning('กรุณาระบุผู้ขอเบิก');
      return
    }

    if(this.state.use_for === 'ใช้กับรถยนต์'){
      if(this.state.carUseIn.car_id === ''){
        AlertWarning('ใช้กับรถยนต์ กรุณาระบุรถที่นำไปใช้งาน')
        return
      }
    }

    if(this.state.use_for === 'ใช้กับรถยนต์ภายนอก'){
      if(this.state.car_license === ''){
        AlertWarning('ใช้กับรถยนต์ภายนอก \nกรุณาระบุทะเบียนรถ')
        return
      }
    }

    if(this.state.stockOutItem.length === 0){
      AlertWarning('กรุณาเพิ่มรายการอะไหล่อย่างน้อย 1 รายการ');
      return
    }

    let out_date = this.state.out_date ;
    let user = this.props.user.user;
    let stockOutItem = this.state.stockOutItem;
    let requestor = this.state.requestor;
    let out_note = this.state.out_note;
    let use_for = this.state.use_for;
    let car_id = this.state.carUseIn.car_id;
    let car_sell_id = this.state.carUseIn.car_sell_id === undefined ? 0 : this.state.carUseIn.car_sell_id ;
    let car_name = this.state.carUseIn.car_name;
    let is_save_carrepair = this.state.company_setting.is_save_carrepair
    let center_id = this.state.center.center_id
    let out_date_format = format(new Date(out_date), 'yyyy-MM-dd');
    let car_license = this.state.car_license
    let is_after_sell = this.state.is_after_sell

    // TODO: out_note add
    let data = {
      out_date: out_date_format,
      requestor:requestor,
      out_note: out_note,
      use_for: use_for,
      car_id: car_id,
      car_name: car_name,
      user: user,
      stockOutItem: stockOutItem,
      is_save_carrepair: is_save_carrepair,
      center_id: center_id,
      car_sell_id: car_sell_id,
      car_license: car_license,
      is_after_sell: is_after_sell
    }


    axios.post(APIURL+'/stock_out', data)
      .then(res => {
        if(res.status === 200) {
          // alert('เบิกอะไหล่เรียบร้อยแล้ว');
          AlertSuccess('เบิกอะไหล่เรียบร้อยแล้ว');
          this.setState({
            stockOutItem: []
          },()=> {
            this.props.onReloadSummary()
            this.props.onToggleTab('1')
          });
        }
      })
  }

  selectCarUseIn(car) {

    let car_sell = car.car_sell_id === null ? '' : ' - ขายแล้ว'

    this.setState({
      carUseIn: {
        car_id: car.car_id,
        car_name: car.car_name,
        car_sell_id: car.car_sell_id === null ? 0 : car.car_sell_id,
        car_license_plate_new: car.car_license_plate_new === '' ? car.car_license_plate_old+'(เดิม)'+car_sell : car.car_license_plate_new+car_sell
      },
      is_after_sell: car.car_sell_id === null ? 0 : 1,
      carSearchResult: []
    },()=>{
      this.refs.car_search.value = ''
    });
  }

  removeStockItem(itemStock) {
    let stockOutItem = this.state.stockOutItem;
    let indexRemove = stockOutItem.indexOf(itemStock);
    if(indexRemove !== -1) {
      stockOutItem.splice(indexRemove, 1);
      this.setState({
        stockOutItem: stockOutItem,
      });
    }
  }

  // company_setting.is_save_carrepair
  loadCompanySetting() {
    axios.get(APIURL + '/company_setting/1').then(res => {
      let data = res.data
      let company_setting = data.company_setting
      this.setState({
        company_setting: company_setting
      })
    })
  }

  loadCenter() {
    axios.get(APIURL + '/stock_out/center').then(res => {
      let data = res.data[0]
      this.setState({
        center: data
      })
    })
  }

  render() {

    let car_name = this.state.carUseIn.car_name;
    let out_date = this.state.out_date;
    let car_license_plate_new = this.state.carUseIn.car_license_plate_new

    let carSearchResult = this.state.carSearchResult.map((car, index) => {
      let car_license = car.car_license_plate_new === '' ? 'เดิม: '+car.car_license_plate_old : car.car_license_plate_new
      let car_sell = car.car_sell_id === null ? '' : ' - ขายแล้ว'
      return (
        <div className="row col-12"
             key={index}
             onClick={()=>this.selectCarUseIn(car)}
             style={{cursor: 'pointer', width: '300px'}}
        >
          <div className="col-9 text-right">
            {car_license} {car_sell}
          </div>
          <div className="col-3 text-right text-success">
             เลือก
          </div>
        </div>
      )
    });

    let sparePartSearchResult = this.state.sparePartSearchResult.map((sparePartSearch,index) =>{

      if(sparePartSearch.quantity_in===0)
        return null;

      return (
        <div
          className="col-12"
          style={{cursor: 'pointer', height: '30px'}}
          key={index}
          onClick={()=>this.addStockOutItem(sparePartSearch)}
        >{sparePartSearch.name} (สต๊อก : {sparePartSearch.quantity_in})</div>
      )
    });

    let sparePartSearchBarCodeResult = this.state.sparePartSearchBarCodeResult.map((sparePartSearch,index) =>{

      if(sparePartSearch.quantity_in===0)
        return null;

      return (
          <div
              className="col-12"
              style={{cursor: 'pointer', height: '30px'}}
              key={index}
              onClick={()=>this.addStockOutItem(sparePartSearch)}
          >{sparePartSearch.name} (สต๊อก : {sparePartSearch.quantity_in})</div>
      )
    });

    let stockOutItemList = this.state.stockOutItem.map((item,index) =>{
      return (
        <tr key={index}>
          <td>{index+1}</td>
          <td>{item.name}</td>
          <td className="text-center">{item.price}</td>
          <td className="text-center" style={{width:'20%'}}>
            <input type="text"
                   className="text-center form-control"
                   value={item.quantity}
                   onChange={(event)=>this.updateStockItem(event,item)}
                   onKeyDown={(e) => {
                     if(e.keyCode === 13) {
                       e.preventDefault();
                     }
                   }}
            />
          </td>
          <td className="text-center" >{item.unit}</td>
          <td className="text-center" >
            <button className="btn btn-sm btn-danger btn-md-width"
                    onClick={()=>this.removeStockItem(item)}
            >
              <i className="fa fa-remove"/> ลบ
            </button>
          </td>
        </tr>
      )
    });

    // <form onSubmit={this.onSubmitStockOut}>
    return (

        <div className="row">
          <div className="col-lg-12">
            <div className="card card-accent-warning">
              <div className="card-header card-sparepart">

                <strong className="text-title">เบิกอะไหล่</strong>

                {/*<strong
                  className="text-success float-right"
                  style={{cursor: 'pointer'}}
                >ประวัติการเบิก</strong>*/}

              </div>

              <div className="card-block">

                <div className="row">
                  <div className="form-group col-sm-2 ml-3">
                    <label className="pt-2">วันที่เบิก</label>
                    <DatePicker
                      name="out_date"
                      selected={this.state.out_date}
                      onChange={this.handleOutDate}
                      dateFormat="yyyy-MM-dd"
                      type="text"
                      className="form-control"
                      placeholder=""
                    />
                  </div>
                  {/*<div className="form-group col-sm-2">

                  </div>*/}

                  <div className="form-group col-sm-2">
                    <label className="pt-2">ผู้ขอเบิก </label>
                    <input name="requestor"
                           type="text"
                           className="form-control"
                           placeholder="ผู้ขอเบิก"
                           value={this.state.requestor}
                           onChange={(event)=>this.setState({requestor: event.currentTarget.value})}
                    />
                  </div>
                  {/*<div className="form-group col-sm-2">

                  </div>*/}
                  <div className="form-group col-5">
                    <label className="pt-2">ประเภทการใช้งาน </label>
                    <br/>
                    <input type="radio"
                           name="use_for"
                           value="ใช้ในเต็นท์รถ"
                           className="btn btn-primary"
                           defaultChecked={this.state.use_for === 'ใช้ในเต็นท์รถ'}
                           onChange={this.onChangeUseFor}
                    /> &nbsp;<span style={{marginTop: -4}}>ใช้ในเต็นท์รถ</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio"
                           name="use_for"
                           value="ใช้กับรถยนต์"
                           className="btn btn-primary"
                           defaultChecked={this.state.use_for === 'ใช้กับรถยนต์'}
                           onChange={this.onChangeUseFor}
                    /> &nbsp;<span style={{marginTop: -4}}>ใช้กับรถยนต์</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="radio"
                           name="use_for"
                           value="ใช้กับรถยนต์ภายนอก"
                           className="btn btn-primary"
                           defaultChecked={this.state.use_for === 'ใช้กับรถยนต์ภายนอก'}
                           onChange={this.onChangeUseFor}
                    /> &nbsp;<span style={{marginTop: -4}}>ใช้กับรถยนต์ภายนอก</span>
                  </div>

                  <div className="form-group col-2">
                    <label className="pt-2">ค้นทะเบียนรถ </label>
                    <input
                      ref="car_search"
                      onChange={this.onChangeSearchCar}
                      onKeyDown={this.onChangeSearchCar}
                      placeholder="ค้นทะเบียนรถ"
                      className="form-control"
                      size="16"
                      type="text"
                      disabled={this.state.use_for !== 'ใช้กับรถยนต์'}
                    />
                    <div className="row mt-2 float-right" style={{zIndex: 9999}}>
                      {carSearchResult}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group ml-1 col-2">
                    <label className="pt-2">ทะเบียนรถภายนอก</label>
                    <input name="car_license"
                           type="text"
                           className="form-control"
                           placeholder="ทะเบียนรถภายนอก"
                           maxLength={50}
                           disabled={this.state.use_for !== 'ใช้กับรถยนต์ภายนอก'}
                           value={this.state.car_license}
                           onChange={(event) => {
                             let value = event.currentTarget.value
                             this.setState({car_license: value})
                           }}
                    />
                  </div>

                  <div className="form-group col-sm-5">
                    <label className="pt-2">หมายเหตุ</label>
                    <input name="out_note"
                           type="text"
                           className="form-control"
                           placeholder="หมายเหตุ"
                           maxLength={200}
                           value={this.state.out_note}
                           onChange={(event) => {
                             let value = event.currentTarget.value
                             this.setState({out_note: value})
                           }}
                    />
                  </div>

                  <div className="form-group col-sm-3">
                    <label className="pt-2">ประเภทการซ่อม</label>
                    <select
                    name='is_after_sell'
                    className="form-control"
                    value={this.state.is_after_sell}
                    onChange={(e)=> {
                       let val = e.target.value
                       this.setState({is_after_sell: val})
                    }}
                    >
                      <option value={0}> ซ่อมก่อนขาย </option>
                      <option value={1}> ซ่อมหลังขาย </option>
                    </select>
                  </div>
                </div>

                <div className="row pt-3" style={{backgroundColor: '#eceff1'}}>
                  <div className="form-group col-4">
                   วันที่เบิก: {moment(out_date).locale('th').format('LL') }
                  </div>
                  <div className="form-group col-4">
                   ชื่อรถ: {car_name}
                  </div>
                  <div className="form-group col-4">
                    ทะเบียนรถ: {car_license_plate_new}
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="form-group col-sm-6">
                    <label >ค้นหาตามชื่อ </label>
                    <input
                      ref="search_spare_part_out"
                      onChange={this.onChangeSearchSparePart}
                      onKeyDown={this.onKeyDownSearchSparePart}
                      placeholder="ชื่ออะไหล่"
                      className="form-control"
                      size="16"
                      type="text"/>
                    <div className="row mt-2">
                      {sparePartSearchResult}
                    </div>
                  </div>

                  <div className="form-group col-sm-6">
                    <label  >ค้นหาบาร์โค้ด </label>
                    <input
                        onChange={this.onChangeSearchBarCodeSparePart}
                        onKeyDown={this.onKeyUpSearchBarCodeSparePart}
                        placeholder="บาร์โค้ดอะไหล่"
                        className="form-control"
                        value={this.state.spare_part_barcode}
                        size="16"
                        type="text"
                    />
                    <div className="row mt-2">
                      {sparePartSearchBarCodeResult}
                    </div>
                  </div>
                </div>

                {
                  this.state.company_setting.is_save_carrepair === 1 &&
                  this.state.use_for === 'ใช้กับรถยนต์' ? (
                    <>
                       <div className="row">
                         <div className="form-group col-sm-12 text-danger">
                          *** บันทึกการเบิกอะไหล่เป็นค่าใช้จ่ายในการซ่อม
                         </div>
                       </div>
                    </>
                  ) : null
                }

                <div className="row">
                  <div className="col-12">
                    <table className="table table-striped">
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>ชื่ออะไหล่รถ</th>
                        <th className="text-center">ราคาต่อหน่วย</th>
                        <th className="text-center">จำนวน</th>
                        <th className="text-center">หน่วย</th>
                        <th className="text-center">จัดการ</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr className={this.state.stockOutItem.length===0? '': 'hidden'} >
                        <td colSpan={6} className="text-center text-danger">
                          ไม่พบรายการอะไหล่
                        </td>
                      </tr>
                      {stockOutItemList}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button type="reset"
                        className="btn btn-sm btn-danger mr-2"
                >
                  <i className="fa fa-refresh"/> ยกเลิก
                </button>
                <button type="button"
                        onClick={(e) => this.onSubmitStockOut(e)}
                        className={this.state.actionType==="แก้ไข"? "btn btn-sm btn-warning" :"btn btn-sm btn-primary"}
                >
                  <i className={this.state.actionType === "แก้ไข" ? "fa fa-edit" : "fa fa-save"}/>
                  &nbsp;{this.state.actionType}
                </button>
              </div>

            </div>
          </div>
        </div>

    )
  }
}

export default SparePartStockOut;
